import { useEffect } from "react";
import SupabasePool from "@/lib/supabaseClient";
import { getAdminByEmail } from "@/services/getAdminByEmail";
import { useAuthActions, useAuthentication } from "@/hooks/useAuth";

export const AuthInitializer = () => {
  const authentication = useAuthentication();
  const { removeAuth, setAuth } = useAuthActions();

  useEffect(() => {
    // 인증 안 되어 있으면 아무것도 안함
    if (!authentication) return;

    // async 작업은 effect 내부에서 정의 후 호출
    const init = async () => {
      const pool = SupabasePool.getInstance();

      const { data: session } = await pool.auth.getSession();

      if (!session?.session?.user?.email) {
        removeAuth();
        return;
      }

      // 어드민 조회
      const admin = await getAdminByEmail({
        pool,
        email: session.session.user.email,
      });

      if (!admin.ok || admin.error) {
        removeAuth();
        throw new Error("관리자 정보 조회 실패");
      }

      setAuth(admin.data);
    };

    init();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
